export const GET_WORKOUT_LOGS_SUCCESS =
  'Client/GET_WORKOUT_LOGS_SUCCESS';
export const GET_WORKOUT_LOGS_ERROR =
  'Client/GET_WORKOUT_LOGS_ERROR';
export const LOADING_STATE = 'LOADING_STATE';

